<!-- @format -->

<template>
	<el-dialog
		v-model="dialogVisible"
		:title="title"
		custom-fullscreen-class="ibps-dialog-70"
		:class="isReset ? 'other-changePassword_dialog' : 'super-changePassword_dialog'"
		width="600px"
		@open="formValidate"
		@close="closeDialog"
	>
		<el-form
			ref="passwordForm"
			v-loading="dialogLoading"
			class="platform-input-sty"
			element-loading-text="加载中"
			:model="password"
			:rules="rules"
			label-position="right"
			label-width="100px"
			@submit.prevent
		>
			<el-row :gutter="30">
				<el-col :span="24">
					<el-form-item v-if="!isReset" label="原密码" prop="primitivePassword">
						<el-input v-model="password.primitivePassword" type="password" autocomplete="off" show-password />
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="新密码" prop="newPassword">
						<el-input
							v-model="password.newPassword"
							:type="passwordShowT ? 'password' : 'text'"
							autocomplete="off"
							show-password
						>
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="24">
					<el-form-item label="重复密码" prop="repeatPassword">
						<el-input
							v-model="password.repeatPassword"
							:type="passwordShow ? 'password' : 'text'"
							autocomplete="off"
							show-password
						>
						</el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>

		<template #footer>
			<pc-toolbar :actions="toolbars" @action-event="handleActionEvent" />
		</template>
	</el-dialog>
</template>
<script>
	import { ElMessage } from 'element-plus';
	import { PcToolbar } from '@/components/pc-toolbar/index';
	import { editPassword, getDefaultUserSecurity, ChangePassword } from '@/api/user/index';
	// import { mapActions } from 'vuex'
	// import { ActionUtils } from '@/utils/action';
	import { $utils } from '@/utils/publicUtils';
	import { encodeStr } from '@/utils/encrypt';
	import { getPublicKey } from '@/api/login';
	const userSecurityText = {
		1: '小写字母',
		2: '大写字母',
		3: '数字',
		4: '特殊符号',
	};
	const userSecurityRegx = {
		1: /[a-z]/g,
		2: /[A-Z]/g,
		3: /\d+/g,
		4: /((?=[\x21-\x7e]+)[^A-Za-z0-9])/g,
	};
	export default {
		components: {
			PcToolbar,
		},
		props: {
			title: {
				type: String,
				default() {
					return '修改密码';
				},
			},
			visible: Boolean,
			ids: String,
			regOpen: {
				type: Boolean,
				default: false,
			},
			isReset: {
				// 是否重置
				type: Boolean,
				default: false,
			},
		},
		data() {
			const validatePassword = (rule, value, callback) => {
				if ($utils.isEmpty(value)) {
					callback('必填');
					return;
				}
				const reg = /(^\s+)|(\s+$)|\s+/g;
				const userSecurity = rule.userSecurity;
				// 未设置复杂度
				if ($utils.isEmpty(userSecurity)) {
					if (reg.test(value)) {
						callback(new Error('请勿携带空格字符'));
					} else {
						callback();
					}
					return;
				}

				// 最小长度 ,最大长度
				if (value.length < userSecurity.minLength || value.length > userSecurity.maxLength) {
					const msg = `最小长度${userSecurity.minLength};` + `最大长度${userSecurity.maxLength}`;
					callback(new Error(msg));
					return;
				}

				const flag = [];
				for (const l in userSecurityRegx) {
					if (value.match(userSecurityRegx[l]) !== null) {
						flag.push(l);
					}
				}
				const complexity = userSecurity.complexity || [];
				const arrMsg = [];
				for (let i = 0; i < complexity.length; i++) {
					arrMsg.push(userSecurityText[parseInt(complexity[i])]);
				}
				const isContained = (a, b) => {
					// a和b其中一个不是数组，直接返回false
					if (!(a instanceof Array) || !(b instanceof Array)) return false;
					const len = b.length;
					// a的长度小于b的长度，直接返回false
					if (a.length < len) return false;
					for (let i = 0; i < len; i++) {
						// 遍历b中的元素，遇到a没有包含某个元素的，直接返回false
						if (!a.includes(b[i])) return false;
					}
					// 遍历结束，返回true
					return true;
				};
				// 正则匹配
				if (isContained(flag, [...userSecurity.complexity]) == false) {
					const msg = `必须包含${arrMsg.join(',')}`;
					callback(new Error(msg));
				} else {
					callback();
				}
			};
			const validateRepeatPassword = (rule, value, callback) => {
				const reg = /(^\s+)|(\s+$)|\s+/g;
				if (this.restoreDefaultPassW !== '') return;
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.password.newPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else if (reg.test(value)) {
					callback(new Error('请勿携带空格字符!'));
				} else {
					callback();
				}
			};
			return {
				formName: 'passwordForm',
				dialogLoading: false,
				dialogVisible: this.visible,
				restoreDefaultPassW: '',
				flags: false,
				flagt: false,
				passwordShow: 'password',
				passwordShowT: 'password',
				rules: {
					primitivePassword: [{ required: true, message: '必填' }],
					newPassword: [
						{ required: true, message: '必填' },
						{
							validator: (rule, value, callback) => {
								rule.userSecurity = this.userSecurity;
								validatePassword(rule, value, callback);
							},
							trigger: ['change', 'blur'],
						},
					],
					repeatPassword: [
						{ required: true, message: '必填' },
						{ validator: validateRepeatPassword, trigger: 'change' },
					],
				},
				password: {
					userIds: [],
					// isReset: 0, // 是否重置，0-非重置、非0-重置
					newPassword: '', // 新密码
					repeatPassword: '', // 重复密码
					primitivePassword: '', // 原始密码
				},
				toolbars: [
					// {
					//   key: 'reset',
					//   label: '还原默认',
					//   hidden: () => {
					//     return !this.isReset;
					//   },
					// },
					{ key: 'save', type: 'primary', size: 'default' },
					{
						key: 'cancel',
						hidden: () => {
							return this.isReset;
						},
						size: 'default',
					},
				],

				// 用户安全设置
				userSecurity: {
					complexity: [],
					maxLength: 0,
					minLength: 0,
				},
				complexityArray: [
					{
						name: '小写字母',
						value: '1',
					},
					{
						name: '大写字母',
						value: '2',
					},
					{
						name: '数字',
						value: '3',
					},
					{
						name: '特殊符号',
						value: '4',
					},
				],
			};
		},
		watch: {
			visible: {
				handler() {
					this.dialogVisible = this.visible;
				},
				immediate: true,
			},
		},
		beforeUnmount() {
			this.rules = null;
			this.password = null;
			this.toolbars = null;
			this.userSecurity = null;
		},
		methods: {
			//   ...mapActions({
			//     'logout': 'ibps/account/logout'
			//   }),
			handleGetDefaultUserSecurity() {
				getDefaultUserSecurity()
					.then((response) => {
						const data = response;
						if ($utils.isEmpty(data)) {
							this.userSecurity = {};
							return;
						}

						const newComplexity = [];
						const resdata = data.complexity.split(',');
						this.complexityArray.map((item) => {
							resdata.map((val) => {
								if (item.name == val) {
									newComplexity.push(item.value);
								}
							});
						});
						// this.userSecurity.complexity = data.complexity.split(',').sort();
						this.userSecurity.complexity = newComplexity.sort();
						this.userSecurity.maxLength = data.maxLength;
						this.userSecurity.minLength = data.minLength;
					})
					.catch(() => {});
			},
			handleActionEvent({ key }) {
				switch (key) {
					case 'save':
						this.handleSave();
						break;
					case 'reset':
						this.restoreDefault();
						break;
					case 'cancel':
						this.closeDialog();
						break;
					default:
						break;
				}
			},
			/**
			 * @description 登出
			 */
			// logOff() {
			// 	this.logout({
			// 		vm: this,
			// 		confirm: false,
			// 	});
			// },
			// 提交（校验）
			handleSave(restoreDefault = false) {
				if (this.isReset) {
					//  修改密码
					this.rules['primitivePassword'] = [{ required: false, message: '必填' }];
				}
				if (restoreDefault) {
					this.saveData(restoreDefault);
				} else {
					this.$refs[this.formName].validate((valid) => {
						if (valid) {
							this.saveData();
						} else {
							// ActionUtils.saveErrorMessage();
						}
					});
				}
			},
			// 提交保存数据
			async saveData(restoreDefault = false) {
				const formData = JSON.parse(JSON.stringify(this.password));
				formData.userIds.push(this.ids);
				if (restoreDefault) {
					delete formData.newPassword;
					delete formData.primitivePassword;
					delete formData.repeatPassword;
				}
				// // 处理密码加密
				const res = await getPublicKey();

				if (!restoreDefault) {
					if (!this.isReset) {
						// 不是重置需要修改
						formData.primitivePassword = await encodeStr(formData.primitivePassword, res.data.publicKey);
					}
					formData.newPassword = await encodeStr(formData.newPassword, res.data.publicKey);
					formData.repeatPassword = await encodeStr(formData.repeatPassword, res.data.publicKey);
				}
				// const regOpen = this.$store.getters.regOpen
				const regOpen = false;
				// 是否开启注册
				if (regOpen) {
					// formData.reset = 0 // 0-非重置、1-重置,2-重置默认
					// registerChangePassword(formData).then(response => {
					//   ActionUtils.saveSuccessMessage(response.message, (rtn) => {
					//     this.logOff()
					//     if (rtn) {
					//       this.closeDialog()
					//     }
					//   })
					// }).catch((err) => {
					//   console.error(err)
					// })
				} else {
					// 0-非重置、1-重置,2-重置默认
					// const reset = restoreDefault ? 2 : this.isReset ? 1 : 0;
					formData.reset = '1';
					if (this.isReset) {
						ChangePassword({ ...formData, keyId: res.data.keyId })
							.then(() => {
								ElMessage({
									message: '重置成功',
									type: 'success',
								});
								this.closeDialog();
							})
							.catch((err) => {
								console.error(err);
							});
					} else {
						editPassword({
							primitivePassword: formData.primitivePassword,
							newPassword: formData.newPassword,
							keyId: res.data.keyId,
						})
							.then(() => {
								ElMessage({
									message: '修改成功',
									type: 'success',
								});
								this.closeDialog();
								// });
							})
							.catch((err) => {
								console.error(err);
							});
					}
				}
			},
			/**
			 * 还原默认
			 */
			restoreDefault() {
				this.saveData(true);
			},
			// 关闭当前窗口
			closeDialog() {
				this.restoreDefaultPassW = '';
				this.$emit('close', false);
				this.$refs[this.formName].resetFields(); // 初始化状态
			},
			/**
			 * 表单验证
			 */
			formValidate() {
				// this.$nextTick(() => {
				// 	this.$refs[this.formName].validate(() => {
				//   });
				// });
				this.handleGetDefaultUserSecurity();
			},
		},
	};
</script>
